module.exports = __webpack_public_path__ + "img/vaccine-tracking-button.baab6d34.png";